import { MosaicImage } from '../types';

export const mosaicImages: MosaicImage[] = [
  {
    imagePath: "/gallery/bullseye.jpg",
    altText: "BULLS-EYE",
    url: "https://www.youtube.com/watch?v=-TMqaQAdpvM"
  },
  {
    imagePath: "/gallery/surge.jpg",
    altText: "Mimikyu",
    url: "https://level5robotics.com/rival/surge"
  },
  {
    imagePath: "/gallery/sandstorm_6.9d.jpg",
    altText: "Sandstorm",
    url: "https://dex.level5robotics.com/robot/1"
  },
  {
    imagePath: "/gallery/ditto.jpg",
    altText: "Ditto",
    url: "https://dex.level5robotics.com/robot/18"
  },
  {
    imagePath: "/gallery/mirage_7.0.jpg",
    altText: "Mirage",
    url: "https://dex.level5robotics.com/robot/8"
  },
  {
    imagePath: "/gallery/impact.jpg",
    altText: "Impact",
    url: "https://www.youtube.com/watch?v=9fIZhd-RAhs"
  },
  {
    imagePath: "/gallery/rollout.jpg",
    altText: "Rollout",
    url: "https://dex.level5robotics.com/robot/20"
  },
  {
    imagePath: "/gallery/mimikyu_1.1.jpg",
    altText: "Mimikyu",
    url: "https://dex.level5robotics.com/robot/22"
  },
  
]; 